var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundForehead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 931,
    height: 1024,
    viewBox: "0 0 931 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M931 0.000101715L931 1024L111.001 1024L0.000152588 512L111.001 5.13312e-05L931 0.000101715Z",
    fill: "url(#paint0_linear_720_104255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_104255",
    x1: 111,
    y1: 1024,
    x2: -12.041,
    y2: 69.3585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121419"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundForehead);
export default __webpack_public_path__ + "static/media/BackgroundForehead.44bbfbaebef374e6118bbfe250c26ddd.svg";
export { ForwardRef as ReactComponent };